import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';

export interface FAQProps extends React.HTMLAttributes<HTMLDivElement> {
  question: string;
  answer: string | TrustedHTML;
  open: boolean;
  onToggle: () => void;
}

const FAQ = React.forwardRef<HTMLDivElement, FAQProps>(
  ({ question, answer, onToggle, open, className, ...props }, ref) => {

    return (
      <div
        ref={ref}
        className='space-y-3'
        dir='rtl'
        {...props}
      >
        {!open && (
          <div onClick={onToggle} className='flex items-start justify-start p-3 rounded-lg border border-[var(--border-color)] bg-[var(--input-bg-color)]'>
            <div
              className='ml-2'
            >
              <AddIcon className='w-4 h-4 text-primary' />
            </div>
            <p className='text-[var(--primary-text-color)] text-[.9rem] text-justify font-bold'>{question}</p>
          </div>
        )}

        {open && (
          <div
            id='faq-answer'
            data-testid='faq-answer'
            className='rounded-lg p-3 border border-[var(--border-color)] bg-[var(--input-bg-color)]'
            onClick={onToggle}
          >
            <div className='space-y-2 flex items-start justify-start'>
              <div
                className='ml-2'
              >
                <ClearIcon className='w-4 h-4' />
              </div>
              <div className='!mt-0'>
                <p className='text-[var(--primary-text-color)] text-[.9rem] text-justify font-bold'>
                  {question}
                </p>
                <div className='text-[var(--primary-text-color)] !text-[.875rem] text-justify mt-2' dangerouslySetInnerHTML={{ __html: answer! }} />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
);

FAQ.displayName = 'FAQ';

export default FAQ;
